document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.package-picker').forEach(function (picker) {
    var variantId = picker.getAttribute('data-variant-id');
    var buyNowBtn = picker.querySelector('[data-package-buy-now]');
    var buyNowText = picker.querySelector('[data-package-buy-now-text]');
    var errorEl = picker.querySelector('[data-package-picker-error]');
    var radios = picker.querySelectorAll('.package-picker__radio');
    var originalText = buyNowText ? buyNowText.textContent : '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        picker.querySelectorAll('.package-picker__package').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
        radio.closest('.package-picker__package').classList.add('is-selected');
      });
    });

    if (!buyNowBtn) return;

    buyNowBtn.addEventListener('click', function () {
      var selected = picker.querySelector('.package-picker__radio:checked');

      if (!selected) {
        showError('Selecciona un paquete antes de continuar.');
        return;
      }

      if (!variantId) {
        showError('No se ha encontrado la variante del producto.');
        return;
      }

      hideError();
      setLoading(true);

      var quantity = parseInt(selected.getAttribute('data-quantity'), 10) || 1;

      // 1) Comprobar el carrito actual
      fetch(root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // 2) Solo vaciar si ya hay algo (evita una petición innecesaria en el caso más común)
          if (cart.item_count > 0) {
            return fetch(root + 'cart/clear.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              }
            });
          }
        })
        .then(function () {
          // 3) Añadir el paquete seleccionado
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(variantId, 10),
                  quantity: quantity
                }
              ]
            })
          });
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Error al añadir al carrito');
            });
          }
          return response.json();
        })
        .then(function () {
          // 4) Ir a checkout
          window.location.href = root + 'checkout';
        })
        .catch(function (err) {
          setLoading(false);
          showError(err.message || 'Ha ocurrido un error. Inténtalo de nuevo.');
        });
    });

    function setLoading(isLoading) {
      buyNowBtn.disabled = isLoading;
      if (buyNowText) {
        buyNowText.textContent = isLoading ? 'Processing...' : originalText;
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.hidden = true;
    }

    // Corrige el bug del botón bloqueado tras pulsar "atrás" desde el checkout
    window.addEventListener('pageshow', function () {
      setLoading(false);
      hideError();
    });
  });
});
